module.exports = __webpack_public_path__ + "img/cat-fridge_1500.c098cd06.jpg";